interface Props {
  id: string;
  children: React.ReactNode;
}

/** Errors are announced, not only coloured (docs/REQUIREMENTS.md section 4). */
export function Alert({ id, children }: Props) {
  return (
    <p
      className="rounded-2xl border border-danger/30 bg-danger/10 px-4 py-3 text-sm text-danger-ink"
      id={id}
      role="alert"
    >
      {children}
    </p>
  );
}
